exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".copy-clipboard{cursor:pointer}.fa.copy-clipboard{margin:0 10px;font-size:24px}.copy-successful,.copy-unsuccessful{display:none}.quote-information ul,.quote-items ul{list-style-type:none;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/combined/QuoteModalView.css
// module id = 1999
// module chunks = 0